import React from "react";
import { DynoList } from "../DynoList";
import { Pagination } from "../Pagination";
import { Box, Spinner, Text } from "@chakra-ui/react";
import { ModalBox } from "../ModalBox";
import { ShareDynoModal } from "../ShareDynoModal";
import { Search } from "../Search";
import { useDynoes } from "./useDynoes"
import { LoadingOverlay } from "../LoadingOverlay";

export const Dynoes = () => {
  const {
    publisher,
    searchText,
    searchTextCallback,
    myDynoesLoading,
    myDynoes1Loading,
    searchMyDynoesLoading,
    totalDynoes,
    currentDynosList,
    copyDynoCallback,
    deleteDynoCallback,
    shareCallback,
    shareStatusCallback,
    searchedDynoes,
    currentPage,
    PageSize,
    onPageChange,
    selectedDynoId,
    updateDynoCallback,
    catalogs,
    products,
    dynoList,
    setListCallback,
    onClose,
    isOpen,
    loading,
    openContent
  } = useDynoes();

  return (
    <>
      {loading && <LoadingOverlay />}
      <Search
        placeholder="Search EdDoc"
        searchName={searchText}
        searchTextCallback={searchTextCallback}
      />
      { myDynoesLoading || searchMyDynoesLoading || myDynoes1Loading ? (
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          w="100%"
          h="calc(100vh - 155px)"
        >
          <Spinner
            thickness="4px"
            speed="0.65s"
            emptyColor="gray.200"
            color="blue.500"
            size="xl"
          />
        </Box>
      ) : (
        <>
          {totalDynoes > 0 ? (
            <>
              <DynoList
                dynosList={
                  searchText !== "" ? searchedDynoes : currentDynosList
                }
                isContentPage={false}
                copyDynoCallback={copyDynoCallback}
                deleteDynoCallback={deleteDynoCallback}
                shareCallback={shareCallback}
                modalTitle="Delete EdDoc"
                shareStatusCallback={shareStatusCallback}
                openContent={openContent}
              />
              {searchText !== "" && searchedDynoes.length === 0 && (
                <Box display="flex" alignItems="center" justifyContent="center">
                  <Text fontSize="lg">
                    No search found for the {searchText}
                  </Text>
                </Box>
              )}
              {searchText === "" && (
                <Pagination
                  className="pagination-bar"
                  currentPage={currentPage}
                  totalCount={totalDynoes}
                  pageSize={PageSize}
                  onPageChange={onPageChange}
                />
              )}
            </>
          ) : (
            <Box display="flex" alignItems="center" justifyContent="center">
              <Text fontSize="lg">
                It seems that you haven't created any EdDoc start creating
              </Text>
            </Box>
          )}
          <ModalBox
            title="Share EdDoc"
            description={
              <ShareDynoModal
                selectedDynoId={selectedDynoId}
                publisherId={publisher?.id}
                updateDynoCallback={updateDynoCallback}
                catalogs={catalogs}
                products={products}
                dynoList={dynoList}
                setListCallback={setListCallback}
              />
            }
            onClose={onClose}
            isOpen={isOpen}
            isFooter={false}
          />
        </>
      )}
    </>
  );
};
